import Layout from '../../companyAdmin/layout.vue'
import List from './list.vue'
import Editor from './editor.vue'

const basePath = '/v-admin/client-admin/candidate-status-management'

export default {
  path: `${basePath}`,
  redirect: `${basePath}/list`,
  component: Layout,
  meta: {
    isAllInclude: true,
    isNewPage: true,
    permission: ['PERM_ADMIN_STATUS_MANAGE'],
    menu: {
      labelI18nKey: 'admin.company.candidateStatusManagement.menu'
    }
  },
  children: [
    {
      path: `${basePath}/list`,
      component: List,
      meta: {
        breadcrumb: { hidden: true },
        isNewPage: true,
        titleI18nKey: 'admin.company.candidateStatusManagement.title'
      }
    },
    {
      path: `${basePath}/add`,
      component: Editor,
      meta: {
        isNewPage: true,
        titleI18nKey: 'admin.company.candidateStatusManagement.label.addCandidateStatus'
      }
    },
    {
      path: `${basePath}/edit/:statusKey`,
      component: Editor,
      meta: {
        isNewPage: true,
        isEdit: true,
        titleI18nKey: 'admin.company.candidateStatusManagement.label.editCandidateStatus'
      }
    }
  ]
}
